import i18n, { type TFunction } from 'i18next';

/**
 * The object limit's refusal (#2202; the trial's or the contract's), in the operator's language.
 *
 * Every create path answers 409 with `{ code: 'object_limit', unit, max,
 * current, message }` (`@kolula/shared` objectLimit.ts). The `message` is the
 * server's English sentence; this turns the body into "Deine Testphase umfasst
 * 2 Räume …" so a refused create says why, and what to do, instead of a
 * generic failure. Null for any other failure.
 *
 * Called from the two places every create screen reads its error through:
 * `readInventoryFailure` (stations, objects, divide, reactivate, product links)
 * and the room create form. Without a `t` it uses the app's i18next instance,
 * which is what `readInventoryFailure` — not a component — has.
 */
export const objectLimitMessage = (body: unknown, t: TFunction = i18n.t.bind(i18n)): string | null => {
    if (!body || typeof body !== 'object') return null;
    const { code, unit, max, current, basis } = body as Record<string, unknown>;
    if (code !== 'object_limit' || (unit !== 'rooms' && unit !== 'stations' && unit !== 'combined')) return null;
    if (typeof max !== 'number' || typeof current !== 'number') return null;
    // A contract's limit (ADR-0001 Amendment 6) asks to contact kolula; the
    // trial's (and a body without `basis`, from before it existed) to upgrade.
    // Both count rooms and stations together (PO, 2026-11-02); `combined` names both.
    if (basis === 'contract') return t('limits.refused_contract', { count: max, max, current });
    return t(`limits.refused_${unit}`, { count: max, max, current });
};
